import React, { FunctionComponent } from "react";

const ButtonRefreshArrowIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/interface-essential/multimedia-controls/button-refresh-arrow
  return (
    <svg viewBox="-0.25 -0.25 24.5 24.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 14.248L6 18.748 1.5 18.748"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M5.717,18.751A9.753,9.753,0,0,1,16.5,3"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M5.712,18.746A9.72,9.72,0,1,1,9,21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default ButtonRefreshArrowIcon;
